import countries from 'utils/constants/countries';
import { ACTIVATION, IMPORTMODEL, MEDIA } from 'utils/rest';

const getMedias = async () => {
  const tmp = await MEDIA.getMedias();
  const rslt = tmp.map(el => ({
    value: el.ermesMediaKey,
    key: el.ermesMediaKey,
    label: el.name
  }));
  return rslt;
};

const getActivableMedias = async () => {
  const tmp = await ACTIVATION.getActivableMedias();
  const rslt = tmp.map(el => ({
    value: el._id,
    key: el._id,
    label: el.name
  }));
  return rslt;
};

const getPageActivableMedias = async () => {
  const tmp = await ACTIVATION.getActivableMedias();
  const rslt = tmp.reduce((acc, el) => {
    if (el.page === true) {
      acc.push({
        value: el.key,
        key: el.key,
        label: el.name
      });
    }
    return acc;
  }, []);
  return rslt;
};

const getModel = async () => {
  const tmp = await IMPORTMODEL.get();
  const rslt = tmp.map(el => ({
    value: el.model,
    key: el.model,
    label: el.model
  }));
  return rslt;
};

const getCountries = () => {
  return countries.map(el => {
    return { label: el.label, value: el.key, key: el.key };
  });
};

export default {
  media: getMedias,
  activableMedia: getActivableMedias,
  pageActivableMedia: getPageActivableMedias,
  model: getModel,
  countries: getCountries
};
